import {
  applyFullHeadMprSliceViewOptionsToPixels,
  type FullHeadMprSliceViewOptionsView,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

export const applyFullHeadMprSliceViewOptionsToPngUrl = (
  pngUrl: string,
  options: FullHeadMprSliceViewOptionsView,
): Promise<string> =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;

        const context = canvas.getContext('2d');

        if (!context) {
          reject(new Error('2d context is not available'));

          return;
        }

        context.drawImage(image, 0, 0);

        const imageData = context.getImageData(
          0,
          0,
          canvas.width,
          canvas.height,
        );
        const adjusted = applyFullHeadMprSliceViewOptionsToPixels(
          {
            data: imageData.data,
            heightPx: canvas.height,
            widthPx: canvas.width,
          },
          options,
        );

        imageData.data.set(adjusted);
        context.putImageData(imageData, 0, 0);

        resolve(canvas.toDataURL('image/png'));
      } catch (error) {
        reject(error);
      }
    };
    image.onerror = () => reject(new Error('failed to decode tile png'));
    image.src = pngUrl;
  });
